import { createSlice } from "@reduxjs/toolkit";

export const purchaseRequest = createSlice({
  name: "purchaseRequestTabs",
  initialState: {
    currentTabs: 0,
  },

  reducers: {
    updateCurrentTabs: (state = purchaseRequest?.initialState, action) => {
      state.currentTabs = action.payload;
    },
  },
});
export const { updateCurrentTabs } = purchaseRequest.actions;
export default purchaseRequest.reducer;
